import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';

const LoggedOut = () => {
  useEffect(() => {
    // 3 second baad login pe redirect
    const timer = setTimeout(() => {
      window.location.href = '/login';
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#1C1208',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: 'Georgia, serif',
      color: '#F5F0E8',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>👋</div>
        <div style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
          my<em style={{ color: '#C0392B' }}>linx</em>
        </div>
        <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
          Logged out successfully!
        </div>
        <div style={{ fontSize: 14, color: '#8a7a6a', marginBottom: 32 }}>
          Redirecting to login in 3 seconds...
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <Link to="/login" style={{
            background: '#C0392B', color: '#fff', padding: '10px 24px',
            borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 14,
          }}>
            Login again →
          </Link>
          <Link to="/" style={{
            border: '1px solid #2e2416', color: '#F5F0E8', padding: '10px 24px',
            borderRadius: 8, textDecoration: 'none', fontSize: 14,
          }}>
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoggedOut;